import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

type DateLike = string | Date | moment.Moment | null | undefined;

const DATE_FORMAT = 'DD.MM.YYYY';

/**
 * Label of the task term: "no term", yesterday, today and tomorrow (by the end date) are texts,
 * other terms are dates - the whole range when it lasts longer than a day.
 */
export function getTaskDeadlineLabel(termStart: DateLike, termEnd: DateLike, translate: TranslateService): string {
  const noTerm = translate.instant('MyWork.Card.noTerm');
  if (!termEnd) return noTerm;

  const end = moment(termEnd).startOf('day');
  if (!end.isValid()) return noTerm;

  const difference = end.diff(moment().startOf('day'), 'days');
  if (difference === 0) return translate.instant('MyWork.Card.today');
  if (difference === -1) return translate.instant('MyWork.Card.yesterday');
  if (difference === 1) return translate.instant('MyWork.Card.tomorrow');

  return getTaskTermRange(termStart, termEnd) ?? end.format(DATE_FORMAT);
}

/** Full range of the term (a single date when it is one day), null when there is no term. */
export function getTaskTermRange(termStart: DateLike, termEnd: DateLike): string | null {
  if (!termEnd) return null;

  const end = moment(termEnd).startOf('day');
  const start = termStart ? moment(termStart).startOf('day') : null;
  if (!end.isValid()) return null;
  if (!start?.isValid() || start.isSame(end, 'day')) return end.format(DATE_FORMAT);

  return `${start.format(DATE_FORMAT)} – ${end.format(DATE_FORMAT)}`;
}

export function getTaskDeadlineTone(termEnd: DateLike): 'today' | 'past' | 'normal' {
  if (!termEnd) return 'normal';

  const end = moment(termEnd).startOf('day');
  if (!end.isValid()) return 'normal';

  const difference = end.diff(moment().startOf('day'), 'days');
  return difference < 0 ? 'past' : difference === 0 ? 'today' : 'normal';
}
